// Shared material-shortage dialog — the structured "what's holding this
// back" view (Material / Required / Available / Shortage). Used by:
//  - MaterialStatusChipV2 (click on the "N Materials Missing" chip)
//  - ShopFloorTerminalV2's completion pre-flight (hard block)

import React from 'react';
import {
  Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle,
  Table, TableBody, TableCell, TableHead, TableRow, Typography,
} from '@mui/material';
import { Block } from '@mui/icons-material';

export default function MaterialShortageDialogV2({
  open,
  onClose,
  woNumber,
  shortages = [],
  title = 'Production Blocked - Material Shortage',
  intro = 'The following materials are not available in sufficient quantities:',
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      data-testid="material-shortage-dialog"
    >
      <DialogTitle sx={{ bgcolor: 'error.main', color: 'white' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Block /> {title}
        </Box>
      </DialogTitle>
      <DialogContent>
        <Alert severity="error" sx={{ mt: 2, mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            Work order: {woNumber}
          </Typography>
          <Typography>{intro}</Typography>
        </Alert>
        <Table data-testid="material-shortage-table">
          <TableHead>
            <TableRow>
              <TableCell>Material</TableCell>
              <TableCell align="right">Required</TableCell>
              <TableCell align="right">Available</TableCell>
              <TableCell align="right">Shortage</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {shortages.map((s) => (
              <TableRow key={s.item_id || s.item_code} sx={{ backgroundColor: '#fff3e0' }}>
                <TableCell>
                  <Typography variant="body2" fontWeight="bold">{s.item_name}</Typography>
                  <Typography variant="caption" color="text.secondary">{s.item_code}</Typography>
                </TableCell>
                <TableCell align="right">{s.required}</TableCell>
                <TableCell align="right">
                  <Typography color="error.main">{s.available}</Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography color="error.main" fontWeight="bold">-{s.shortage}</Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" data-testid="material-shortage-close">
          Understood
        </Button>
      </DialogActions>
    </Dialog>
  );
}
